import { Component, OnInit, HostBinding } from '@angular/core';
import { AccountConfigService } from '../../../services/account-config/account-config.service';
import { AuthService } from '../../../../auth/services/auth/auth.service';
import { MGridSettings, MUser } from '@argalis-apps/models';
import { SessionService } from '../../../services/session/session.service';
import { Router } from '@angular/router';
import config from './session-list.config';
import moment from "moment";

@Component({
  selector: 'ags-session-list',
  templateUrl: './session-list.component.html',
  styleUrls: ['./session-list.component.scss']
})
export class SessionListComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  public sessionList: any[] = [];
  public gridSettings: MGridSettings.IGridSettings = config ;
  public userConnected: MUser.CUser;

  constructor(
    private accountConfigService: AccountConfigService,
    private authService: AuthService,
    private sessionService: SessionService,
    private router: Router
  ) {
    this.userConnected = this.authService.userConnected;
    this.authService.userChange.subscribe((user: MUser.CUser) => {
      if (user && !user.login) this.userConnected = null;
      else this.userConnected = Object.assign({}, user);
    });
    this.sessionService
      .getListOfSessionByIntervenant(this.userConnected.userInfo.id, this.userConnected.userInfo.b_ost)
      .subscribe(res => {
        this.sessionList = res;
        this.sessionList.map(item => {
          item.j1 = item.j1
          ? new Date(
              `${moment(item.j1).format("YYYY-MM-DD")}T00:00:00`
            )
          : "";
          item.jdernier = item.jdernier
          ? new Date(
              `${moment(item.jdernier).format("YYYY-MM-DD")}T00:00:00`
            )
          : "";
          return item;
        })
      });
  }

  ngOnInit() {
    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
  }

  public goSession(id: any) {
    this.router.navigate([`account/sessions/ficheSession/${id}`]);
  }

}
